import { IDs } from '../../../helpers/IDs';
import { getDataForKraftstoff } from './getDataForKraftstoff';
import { getCO2Aequivalent, getCO2AequivalentGasKeys } from '../getCO2Aequivalent';
import { getDatenqualitaet } from '../getDatenqualitaet';

export function processSubscope13(part: number, row: any, data: any, item: any, jahr: number, arr: Array<any>, standort: any) {
    // console.log('SS13_' + part, row, standort);
    row = { ...row };
    const key_wert = 'co2_fussabdruck_s3_ss13_' + part + '_wert';
    const key_items = 'co2_fussabdruck_s3_ss13_' + part + '_items';
    const key_datenqualitaet = 'co2_fussabdruck_s3_ss13_' + part + '_datenqualitaet';

    if (!item[key_items]) {
        item[key_items] = [];
    }

    let menge = 0;
    if (part === 1) {

        const keys1_1 = ['bio_brennholz', 'bio_brennholz_rm', 'bio_hackschnitzel', 'bio_hackschnitzel_srm', 'bio_holzpellets', 'bio_holzpellets_kg', 'erdgas', 'erdgas_kwh', 'erdgas_l', 'erdgas_m3', 'fluessiggas', 'fluessiggas_liter', 'fluessiggas_kg', 'hel_liter', 'hel', 'andere', 'braunkohle_kg', 'braunkohle', 'steinkohle_kg', 'steinkohle', 'biogas_m3', 'biogas_kg', 'biogas'];
        const keys1_3 = getCO2AequivalentGasKeys(data);

        let co2_waerme = keys1_1.reduce((acc: number, k: string) => acc += item['co2_fussabdruck_' + k + '_wert'] || 0, 0);
        let co2_gase = keys1_3.reduce((acc: number, k: string) => acc += item['co2_fussabdruck_' + k + '_wert'] || 0, 0);
        let co2_fernwaerme = item.co2_fussabdruck_fernwaerme_wert || 0;
        let co2_strom = item.co2_fussabdruck_strom_wert || 0;

        // WKETOOL-203: Bereich 3.13.1 - Fehlerhafte Berechnung der Abzüge
        if (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] && row.standort_tid_orig > 0
            && data[IDs.KENNZIFFERN_BERECHNET_STANDORT][row.standort_tid_orig]
            && data[IDs.KENNZIFFERN_BERECHNET_STANDORT][row.standort_tid_orig][jahr]) {
            const kennStandort = data[IDs.KENNZIFFERN_BERECHNET_STANDORT][row.standort_tid_orig][jahr];
            co2_fernwaerme = kennStandort.co2_fussabdruck_fernwaerme_wert || 0;
            co2_strom = kennStandort.co2_fussabdruck_strom_wert || 0;
            co2_waerme = keys1_1.reduce((acc: number, k: string) => acc += kennStandort['co2_fussabdruck_' + k + '_wert'] || 0, 0);
            co2_gase = keys1_3.reduce((acc: number, k: string) => acc += kennStandort['co2_fussabdruck_' + k + '_wert'] || 0, 0);
        }

        const days_total = (jahr % 4 === 0 && jahr % 100 !== 0) ? 366 : 365;
        const hours_total = days_total * 24;
        const flaeche = +row.flaeche;
        const flaeche_gesamt = +row.flaeche_gesamt;
        const nutzungszeit = +row.nutzungszeit;
        const vermietungstage = +row.vermietungstage;
        const hours_vermietet = +vermietungstage * nutzungszeit;
        const anteil_flaeche = flaeche / flaeche_gesamt;
        const anteil_stunden = hours_vermietet / hours_total;

        const anteil_strom = co2_strom * anteil_flaeche * anteil_stunden;
        const anteil_fernwaerme = co2_fernwaerme * anteil_flaeche * anteil_stunden;
        const anteil_waerme = co2_waerme * anteil_flaeche * anteil_stunden;
        const anteil_gase = co2_gase * anteil_flaeche * anteil_stunden;

        const key_abzug_strom = 'co2_fussabdruck_abzug_strom_wert';
        const key_abzug_fernwaerme = 'co2_fussabdruck_abzug_fernwaerme_wert';
        const key_abzug_waerme = 'co2_fussabdruck_abzug_waerme_wert';
        const key_abzug_gase = 'co2_fussabdruck_abzug_gase_wert';

        row.value = anteil_strom + anteil_fernwaerme + anteil_waerme + anteil_gase;
        let info = '';
        info += 'Nutzfläche: ' + row.flaeche + 'm²,  ';
        info += row.vermietungstage + 'd,  ';
        info += row.nutzungszeit + 'h/d';
        row.name = row.bemerkung || info;
        row.faktor_einheit = 'Siehe Quelle';
        row.quelle = 'Wert auf Basis der Gesamtemissionen Scope 1 und 2 des jeweiligen Standortes berechnet';
        if (!item[key_abzug_strom]) {
            item[key_abzug_strom] = anteil_strom * -1;
        } else {
            item[key_abzug_strom] += anteil_strom * -1;
        }
        if (!item[key_abzug_fernwaerme]) {
            item[key_abzug_fernwaerme] = anteil_fernwaerme * -1;
        } else {
            item[key_abzug_fernwaerme] += anteil_fernwaerme * -1;
        }
        if (!item[key_abzug_waerme]) {
            item[key_abzug_waerme] = anteil_waerme * -1;
        } else {
            item[key_abzug_waerme] += anteil_waerme * -1;
        }
        if (!item[key_abzug_gase]) {
            item[key_abzug_gase] = anteil_gase * -1;
        } else {
            item[key_abzug_gase] += anteil_gase * -1;
        }
        if (standort || true) {
            item.co2_fussabdruck_scope1 += anteil_waerme * -1;
            item.co2_fussabdruck_scope1 += anteil_gase * -1;
            item.co2_fussabdruck_scope2 += anteil_fernwaerme * -1;
            item.co2_fussabdruck_scope2 += anteil_strom * -1;
            item.co2_fussabdruck_total += anteil_waerme * -1;
            item.co2_fussabdruck_total += anteil_gase * -1;
            item.co2_fussabdruck_total += anteil_fernwaerme * -1;
            item.co2_fussabdruck_total += anteil_strom * -1;
        }

        /* console.log('SS13_1 Abzug ST', co2_strom, anteil_strom);
         console.log('SS13_1 Abzug FW', co2_fernwaerme, anteil_fernwaerme);
         console.log('SS13_1 Abzug WA', co2_waerme, anteil_waerme);
         console.log('SS13_1 Abzug GA', co2_gase, anteil_gase);
         */
    } else
        if (part === 2) { // Fahrzeuge
            const fuel_item = getDataForKraftstoff(row, jahr, data);
            // console.log('9.13.2 Row', row, fuel_item);
            row.name = row.energietraeger_tid;
            row.value = fuel_item.co2;
            menge = row.verbrauch;
            row.einheit = fuel_item.einheit;
            row.faktor = fuel_item.faktor * 1000000;
            row.faktor_einheit = 'gCO₂Äq/' + fuel_item.einheit;
            row.quelle = fuel_item.quelle;
            const in_kraftstoffe = row.in_kraftstoffe_orig;
            if (in_kraftstoffe === 1) {
                const key_abzug = 'co2_fussabdruck_abzug_kraftstoff_wert';
                if (!item[key_abzug]) {
                    item[key_abzug] = row.value * -1;
                } else {
                    item[key_abzug] += row.value * -1;
                }
                if (standort) {
                    item.co2_fussabdruck_scope1 += row.value * -1;
                    item.co2_fussabdruck_total += row.value * -1;
                    // console.log('Abzug', row.value, item.co2_fussabdruck_scope1 , standort);
                }
            } else {

                const obj_dq = {
                    // wert: +sr.verbrauch,
                    wert: fuel_item.co2, // hier Emission t CO2 Äq.
                    emissionsfaktor: +fuel_item.datenqualitaet_1,
                    datenherkunft: +row.datenherkunft,
                    bewertung: +row.datenqualitaet_emissionsfaktor
                };
                // Scope 3.3 bedienen
                const row2: any = {};
                row2.value = fuel_item.co2_s3;
                row2.name = fuel_item.name + ' (aus Subscope 3.13.2)';
                row2.faktor = fuel_item.faktor_s3 * 1000000;
                row2.decimals = 0;
                row2.faktor_einheit = 'gCO₂Äq/' + fuel_item.einheit;
                row2.einheit = fuel_item.einheit;
                row2.quelle = fuel_item.quelle;
                row2.datenqualitaet = getDatenqualitaet(row.datenqualitaet, fuel_item.datenqualitaet_2);
                row2.menge = menge;
                row2.datenqualitaet = getDatenqualitaet([obj_dq], fuel_item.datenqualitaet_1);
                const key_wert_s3 = 'co2_fussabdruck_s3_ss3_wert';
                const key_items_s3 = 'co2_fussabdruck_s3_ss3_items';
                item[key_items_s3].push(row2);
                item[key_wert_s3] = (item[key_wert_s3] || 0) + (fuel_item.co2_s3 || 0);
                // console.log('SS13', key_datenqualitaet, item[key_datenqualitaet]);
            }
        } else
            if (part === 3) {
                // console.log('9.13.3 Row', row);
                let factor = 0;
                let quelle = '';
                let name2 = '';
                const verbrauch = (+row.leistung || 0) * (+row.vermietungstage || 0) * (+row.nutzungszeit || 0);
                if (row.energietraeger_art === 'weitere') {
                    const energietraeger = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER];
                    const energietraeger_tid = row.energietraeger_tid_orig;
                    const energietraeger_obj = energietraeger.find((et: any) => et.tid === energietraeger_tid);
                    if (!energietraeger_obj) {
                        console.log('Kein Energieträger für TID ' + energietraeger_tid);
                        return;
                    }
                    name2 = row.energietraeger_tid;
                    const energietraeger_id = energietraeger_obj.id;
                    const aq = getCO2Aequivalent(data, jahr, energietraeger_id, false);
                    factor = aq.wert;
                    quelle = aq.quelle;
                } else
                    if (row.energietraeger_art === 'kraftstoffe') {
                        const fuel_item = getDataForKraftstoff(row, jahr, data, 'energietraeger_tid2');
                        factor = fuel_item.faktor;
                        name2 = row.energietraeger_tid2;
                        quelle = fuel_item.quelle;
                    } else
                        if (row.energietraeger_art === 'strom') {
                            const aq = getCO2Aequivalent(data, jahr, 'strom', false);
                            factor = aq.wert;
                            name2 = 'Strom';
                            quelle = aq.quelle;
                        }
                // const factor_s3 = aq.wert3;
                menge = verbrauch;
                row.name = row.name ? row.name + ' ' + name2 : '' + name2;
                row.einheit = 'kWh';
                row.faktor = factor * 1000000;
                row.faktor_einheit = 'gCO₂Äq/kWh';
                row.value = factor * verbrauch;
                row.quelle = quelle;
                // console.log('SS13 3', verbrauch, energietraeger_id, aq, row);
            }


    row.menge = menge;
    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + (row.value || 0);
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (row.value || 0);
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row.value || 0);

    // console.log('ITEM NACH 3.13', item);
    // alert('!');
}
